import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaHardHat, FaUsers, FaMedal } from 'react-icons/fa';
import '../styles/About.css';

const About = () => {
  const { t } = useTranslation();

  const values = [
    {
      icon: <FaCheckCircle />,
      title: t('about.qualityCraftsmanship'),
      description: t('about.qualityCraftsmanshipDesc')
    },
    {
      icon: <FaUsers />,
      title: t('about.clientFocused'),
      description: t('about.clientFocusedDesc')
    },
    {
      icon: <FaMedal />,
      title: t('about.integrity'),
      description: t('about.integrityDesc')
    },
    {
      icon: <FaHardHat />,
      title: t('about.safetyFirst'),
      description: t('about.safetyFirstDesc')
    }
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content container">
          <h1>{t('about.title')}</h1>
          <p>{t('about.subtitle')}</p>
        </div>
      </section>

      {/* About Content Section */}
      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>{t('about.whoWeAre')}</h2>
              <p>{t('about.description')}</p>
              <p>{t('about.whoWeAreP1')}</p>
              <p>{t('about.whoWeAreP2')}</p>
            </div>
            <div className="about-image">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=800" 
                alt="Construction team"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title text-center">{t('about.coreValuesTitle')}</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>10+</h3>
              <p>{t('about.statsYears')}</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>{t('about.statsProjects')}</p>
            </div>
            <div className="stat-item">
              <h3>100%</h3>
              <p>{t('about.statsSatisfaction')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container text-center">
          <h2>{t('about.ctaTitle')}</h2>
          <p>{t('about.ctaSubtitle')}</p>
          <a href="mailto:info@aegisconstruction.ca?subject=Construction Project Inquiry&body=Hello,%0D%0A%0D%0AI am interested in discussing a construction project.%0D%0A%0D%0AProject Type: [Residential/Commercial/Renovation]%0D%0ALocation: %0D%0ATimeline: %0D%0ABudget Range: %0D%0A%0D%0APlease contact me to schedule a consultation.%0D%0A%0D%0AThank you!" className="cta-button">
            {t('about.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;